// extracted by mini-css-extract-plugin
module.exports = {"modal":"PokemonPrompt_modal__2b8uw"};